export default {
  id: 62,
  title: 'Target #62 - Sunset',
  url: 'https://cssbattle.dev/play/62',
  colors: ['#191919', '#F2AD43', '#E08027', '#824B20', '#FFF58F'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#191919}a{position:fixed}a[a]{top:50;left:125;width:150;height:185;background:#F2AD43;border-radius:75px}a[b]{top:140;left:170;width:60;height:60;background:#FFF58F;border-radius:50%}a[c],a[d]{top:150;width:100;height:100}a[c]{left:125;background:#E08027;border-radius:0 100px 0 20px}a[d]{right:125;background:#824B20;border-radius:100px 0 20px 0}</style>',
}
